import React from "react";
import {useTranslation} from "react-i18next";
import {useParams} from "react-router-dom";

import {useImportTaskQuery} from "../query";

import Container from "@mui/material/Container";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";

import MDBox from "materialDashboard/components/MDBox";
import MDTypography from "materialDashboard/components/MDTypography";
import BadgeStatus from "../BadgeStatus";
import ErrorTable from "./ErrorTable";
import Icon from "@mui/material/Icon";
import Link from "@mui/material/Link";


const ImportTask = () => {
    const {t} = useTranslation(['importTasks']);
    const {importTaskId} = useParams();

    const importTaskQuery = useImportTaskQuery(importTaskId)

    if (importTaskQuery.isLoading) {
        return null;
    }

    const importTask = importTaskQuery.data;

    let elapsedTime = null;
    if (importTask.startedAt && importTask.completedAt) {
        const startedAt = new Date(importTask.startedAt);
        const completedAt = new Date(importTask.completedAt);
        const diff = completedAt - startedAt;
        elapsedTime = diff/ 1e3;
    }

    return <Container maxWidth="xxl">
        <Grid container columnSpacing={4} rowSpacing={4}>
            <Grid item xs={12} lg={6}>
                <Card>
                    <MDBox py={2} px={2}>
                        <MDTypography variant="h5" fontWeight="medium" textTransform="capitalize">
                            {t("importTask.title")}
                        </MDTypography>
                    </MDBox>
                    <Grid container py={2} px={2} rowSpacing={2}>

                        <Grid item xs={12} md={6}>
                            <MDTypography variant="body2" fontWeight="medium" textTransform="capitalize">
                                {t("importTask.status")}:
                            </MDTypography>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <BadgeStatus status={importTask.status} />
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <MDTypography variant="body2" fontWeight="medium" textTransform="capitalize">
                                {t("importTask.createdAt")}:
                            </MDTypography>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <MDTypography variant="body2" textTransform="capitalize">
                                {importTask.createdAt}
                            </MDTypography>
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <MDTypography variant="body2" fontWeight="medium" textTransform="capitalize">
                                {t("importTask.startedAt")}:
                            </MDTypography>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <MDTypography variant="body2" textTransform="capitalize">
                                {importTask.startedAt}
                            </MDTypography>
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <MDTypography variant="body2" fontWeight="medium" textTransform="capitalize">
                                {t("importTask.completedAt")}:
                            </MDTypography>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <MDTypography variant="body2" textTransform="capitalize">
                                {importTask.completedAt}
                            </MDTypography>
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <MDTypography variant="body2" fontWeight="medium" textTransform="capitalize">
                                {t("importTask.elapsedTime")}:
                            </MDTypography>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <MDTypography variant="body2" textTransform="capitalize">
                                {elapsedTime ? `${elapsedTime} sec` : "-"}
                            </MDTypography>
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <MDTypography variant="body2" fontWeight="medium" textTransform="capitalize">
                                {t("importTask.type")}:
                            </MDTypography>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <MDTypography variant="body2" textTransform="capitalize">
                                {importTask.type}
                            </MDTypography>
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <MDTypography variant="body2" fontWeight="medium" textTransform="capitalize">
                                {t("importTask.format")}:
                            </MDTypography>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <MDTypography variant="body2" textTransform="capitalize">
                                {importTask.format}
                            </MDTypography>
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <MDTypography variant="body2" fontWeight="medium" textTransform="capitalize">
                                {t("importTask.file")}:
                            </MDTypography>
                        </Grid>
                        <Grid item xs={12} md={6} sx={{display: "flex", alignItems: "center", cursor: "pointer"}}>
                            <Link variant="body2" textTransform="capitalize" href={importTask?.file?.path ?? '#'} target="_blank">
                                {importTask.filename}
                            </Link>
                            <Icon>download</Icon>
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <MDTypography variant="body2" fontWeight="medium" textTransform="capitalize">
                                {t("importTask.overwrite")}:
                            </MDTypography>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <MDTypography variant="body2" textTransform="capitalize">
                                {importTask.overwrite ? t("importTask.overwriteEnabled") : t("importTask.overwriteDisabled") }
                            </MDTypography>
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <MDTypography variant="body2" fontWeight="medium" textTransform="capitalize">
                                {t("importTask.notes")}:
                            </MDTypography>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <MDTypography variant="body2" textTransform="capitalize">
                                {importTask.notes}
                            </MDTypography>
                        </Grid>

                    </Grid>
                </Card>
            </Grid>

            <Grid item xs={12} lg={6}>
                <Card>
                    <MDBox py={2} px={2}>
                        <MDTypography variant="h5" fontWeight="medium" textTransform="capitalize">
                            {t("importTask.errorsCardTitle")}
                        </MDTypography>
                    </MDBox>
                    <MDBox py={2} px={2}>
                        <ErrorTable importTaskId={importTask.id} />
                    </MDBox>
                </Card>
            </Grid>

        </Grid>
    </Container>
}

export default ImportTask;